/*
 * Moteur de recherche : Label Terre Saine
 * Charte d'accompagnement : on cache la liste de choix si rien n'est choisi
 */
$('.charte-accompagnement').map(function(){
    $(this).children('.group-content').attr('id','liste-chartes');

    if ($('#liste-chartes').children().length > 1) {
        $('#liste-chartes').css('display','none');
        var newdiv1 = $( "<p id='toggle-chartes'></p>" );
        $(newdiv1).append("<a href='javascript:void(0);' id='link-toggle-chartes'>Choisir une / des charte(s)</a>" );
        $(this).children('.group-name').after($(newdiv1));

        $('#link-toggle-chartes').click(function() {
            $('#liste-chartes').toggle(120);
        });

    }


});